// print env info
// eslint-disable-next-line
console.log(`\
env: ${process.env.BUILD_ENV}
hash: ${process.env.__hash__}
last update: ${process.env.__update__}
publish date: ${process.env.__publish_at__}
============
`)
